(function(globals){

  var except = function(second) {
      return this.filter(i => !second.includes(i));
  };

  if (Object.defineProperty) {
    try {
      Object.defineProperty(Array.prototype, 'except', {
        value: except, configurable: true, enumerable: false, writable: true
      });
    } catch(e) {}
  }

})(this);


// WEBPACK FOOTER //
// ./app/utils/array.prototype.except.js